<template>
    <div class="container">
        <div class="">
            <a name="location"></a>
            <hr/>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4473.715429770316!2d-1.5123346200088972!3d52.310365558250346!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xb15b99fb32fbcad0!2sLogans+Barber+Shop!5e0!3m2!1sen!2suk!4v1546276121751" width="100%" height="600" frameborder="0" style="border:0" allowfullscreen></iframe>
            <hr/>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'location'
    }

</script>
<style scoped>

    iframe {

        height: 600px;

    }

    h1 {

        text-align: center;
        font-size: 4rem;

    }

</style>
